export var ACTION;
(function (ACTION) {
    ACTION["REFRESH_PORTFOLIO"] = "REFRESH_PORTFOLIO";
    ACTION["SET_CREDIT_LIMIT"] = "SET_CREDIT_LIMIT";
    ACTION["VIEW_YOUR_MUTUAL_FUNDS"] = "VIEW_YOUR_MUTUAL_FUNDS";
    ACTION["GO_BACK_ACTION"] = "GO_BACK_ACTION";
})(ACTION || (ACTION = {}));
